import { TableCell, TableRow, Box } from "@mui/material";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { ParagraphText } from "../../../../Libraries";
import useOrderSummary from "../../../../hooks/useOrderSummary";
import { useEffect } from "react";
import { dateFormatInNumberWithSpace, getInitials } from "../../../../utils";
import styles from "./styles.module.css";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const TableRowItem = ({
  order,
  onResume = () => {},
  onDelete = () => {},
  addAmountProperty = () => {},
}) => {
  const { totalAmount } = useOrderSummary({
    sale_order_line: order?.sale_order_line,
    orderDiscount: order?._raw?.discount,
    orderDiscountMethod: order?._raw?.discount_unit,
    orderTax: order?._raw?.tax,
    orderTaxMethod: order?._raw?.tax_type,
  });

  useEffect(() => {
    if (!order.totalAmount && totalAmount) {
      addAmountProperty(totalAmount);
    }
  }, [totalAmount, order]);

  const customerName = order?.customer?.name;

  return (
    <TableRow key={order?._raw?.id} className={styles.tableRow}>
      <TableCell sx={{ textAlign: "left" }}>
        <Box className={styles.customerCell}>
          {customerName ? (
            <span className={styles.customerInitials}>
              {getInitials(customerName)}
            </span>
          ) : null}
          <span className="fontSize14 fontWeight400 newFontColor">
            {customerName ?? "--"}
          </span>
        </Box>
      </TableCell>
      <TableCell>
        {dateFormatInNumberWithSpace(order?._raw?.created_at)}
      </TableCell>
      <TableCell>#{order?._raw?.id.split("-")[0]}</TableCell>
      <TableCell sx={{ textAlign: "right" }}>
        Rs. {formatNum(order?.totalAmount)}
      </TableCell>
      <TableCell>
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          gap={2}
          className={styles.draftTableAction}
        >
          <ParagraphText
            id="resume_draft_sale"
            className={"fontSize14 cursorPointer fontWeight400"}
            onClick={() => {
              triggerLogEvent(analytics, "pos_draft_row_click", {
                action: "resume",
                order_id: order?._raw?.id,
              });
              onResume(order);
            }}
          >
            Resume
          </ParagraphText>
          <ParagraphText
            id="delete_draft_sale"
            className={"fontSize14 fontWeight400 cursorPointer"}
            onClick={() => {
              triggerLogEvent(analytics, "pos_draft_row_click", {
                action: "delete",
                order_id: order?._raw?.id,
              });
              onDelete(order);
            }}
          >
            Delete
          </ParagraphText>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default TableRowItem;
